import {Employee, EmployeeFilter} from '../../models/Employee';
import {PageRequest, PageResult} from '../../models/PageableModel';
import {BaseService} from './BaseService';
import {urls} from './urls';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends BaseService<Employee, EmployeeFilter> implements Resolve<Employee> {

  constructor() {
    super(urls.employee);
  }

  async listInPlanning(pageModel: PageRequest, idPlanning: number, inPlanning: boolean, filter?: EmployeeFilter): Promise<PageResult<Employee>> {
    return this.listIn(pageModel, idPlanning, inPlanning, 'planning', filter);
  }

  async simpleListInPlanning(idPlanning: number, inPlanning: boolean, filter?: EmployeeFilter): Promise<Employee[]> {
    return this.simpleListIn(idPlanning, inPlanning, 'planning', filter);
  }

  async listInSession(pageModel: PageRequest, idSession: number, isSession: boolean, filter?: EmployeeFilter): Promise<PageResult<Employee>> {
    return this.listIn(pageModel, idSession, isSession, 'session', filter);
  }

  async simpleListInSession(idSession: number, isSession: boolean, filter?: EmployeeFilter): Promise<Employee[]> {
    return this.simpleListIn(idSession, isSession, 'session', filter);
  }

  private async listIn(pageModel: PageRequest, idEntity: number, inEntity: boolean, entityType: string, filter?: EmployeeFilter): Promise<PageResult<Employee>> {
    const urlAddition = (inEntity ? '/in/' : '/notIn/') + entityType + '/' + idEntity;
    return this.list(pageModel, filter, urlAddition);
  }

  async simpleListIn(idEntity: number, inEntity: boolean, entityType: string, filter?: EmployeeFilter): Promise<Employee[]> {
    const urlAddition = (inEntity ? '/in/' : '/notIn/') + entityType + '/' + idEntity;
    return this.simpleList(filter, urlAddition);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Employee> {
    return this.fetchById(route.params.id);
  }
}

export const employeeService = new EmployeeService();
